import { SettingsProfile } from '@/features/profile-page/SettingsProfile/ui/SettingsProfile'
import './ui/SettingsProfile.css'
export default SettingsProfile
